module.exports = __webpack_public_path__ + "img/179991.a911ab9f.png";